import { Race } from 'src/app/shared/models/race';
import { Person } from './person';
import { Tag } from './tag';
import { IAddressModel } from './addressModel';
import { DemographicInfo } from './demographicInfo';

/** maps to PersonWriteModel */
export class PersonDetailsWrite implements IAddressModel {
  public id: string;
  public firstName: string;
  public lastName: string;
  public middleName: string;
  public suffix: string;
  public prefix: string;
  public email: string;
  public phoneNumber: string;
  public extension: string;
  public linkedInProfile: string;
  public jobTitle: string;
  public company: string;
  public gender: string;
  public races: Race[];
  public streetAddress1: string;
  public streetAddress2: string;
  public city: string;
  public stateId: string;
  public region: string;
  public countryId: string;
  public postalCode: string;
  public isShared: boolean; //if address is shared
  /** setting this property will cause the address to be validated when submitting application */
  public addressValidationCacheKey: string;
  public status: string;
  public metadata: any;
  public tags: Tag[];
  public secondaryEmails: string[];

  constructor(properties: Partial<PersonDetailsWrite> = undefined) {
    if (properties) this.setProperties(properties);
  }

  private setProperties(properties: Partial<PersonDetailsWrite>) {
    this.id = properties.id;
    this.firstName = properties.firstName;
    this.lastName = properties.lastName;
    this.middleName = properties.middleName;
    this.suffix = properties.suffix;
    this.prefix = properties.prefix;
    this.email = properties.email;
    this.phoneNumber = properties.phoneNumber;
    this.extension = properties.extension;
    this.setLinkedInProfile(properties.linkedInProfile);
    this.jobTitle = properties.jobTitle;
    this.company = properties.company;
    this.gender = properties.gender;
    this.races = properties.races;
    this.streetAddress1 = properties.streetAddress1;
    this.streetAddress2 = properties.streetAddress2;
    this.city = properties.city;
    this.region = properties.region;
    this.postalCode = properties.postalCode;
    this.status = properties.status;
    this.metadata = properties.metadata;
    this.tags = properties.tags;
    this.secondaryEmails = properties.secondaryEmails;
  }

  setAddress(address: DemographicInfo) {
    if (!address) return;
    this.streetAddress1 = address.streetAddress1;
    this.streetAddress2 = address.streetAddress2;
    this.city = address.city;
    this.region = address.region;
    this.postalCode = address.postalCode;
    this.isShared = address.isShared;
    this.stateId = address.state?.id;
    this.countryId = address.country?.id;
  }

  private setLinkedInProfile(linkedInProfile: string) {
    this.linkedInProfile = linkedInProfile ? linkedInProfile.trim() : null;
  }

  public get certMetricsId(): string {
    return this.metadata?.certMetricsId;
  }

  public set certMetricsId(value: string) {
    this.metadata = this.metadata ?? {};
    this.metadata.certMetricsId = value;
  }

  /** convert person to PersonDetailsWrite */
  static parse(person: Person) {
    const secondaryEmails = person.secondaryEmails?.map((e) => e.email) ?? [];
    const model = new PersonDetailsWrite({
      ...person,
      secondaryEmails
    });

    model.gender = person.demographicInfo?.gender;
    model.races = person.demographicInfo?.races;
    model.metadata = { ...person.metadata };
    model.setAddress(person.demographicInfo);

    return model;
  }
}
